import { render, staticRenderFns } from "./SearchFrom2020.vue?vue&type=template&id=28413b69&"
import script from "./SearchFrom2020.vue?vue&type=script&lang=js&"
export * from "./SearchFrom2020.vue?vue&type=script&lang=js&"
import style0 from "./SearchFrom2020.vue?vue&type=style&index=0&id=28413b69&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports